import styles from "./BackToTop.module.scss";

export default function BackToTopIcon() {
  return (
    <svg
      data-testid="back-to-top-icon"
      className={styles["back-to-top__icon"]}
      aria-labelledby="backToTopBtnTitle backToTopBtnDesc"
      viewBox="0 0 48 48"
    >
      <title id="BackToTopLargeIconTitle">Back to top icon</title>
      <desc id="BackToTopLargeIconDesc">
        An icon with an upward arrow inside a circle
      </desc>

      <path d="M24 48C10.8 48 0 37.2 0 24S10.8 0 24 0s24 10.8 24 24-10.8 24-24 24zm0-46.8C11.5 1.2 1.2 11.5 1.2 24S11.5 46.8 24 46.8 46.8 36.5 46.8 24 36.5 1.2 24 1.2z M32.7 22.9L24 14.1l-.7-.7-.7.7h-.1l-8.7 8.8.9.8 7.7-7.9v18H24v-18l7.9 7.9.8-.8z" />
    </svg>
  );
}
